import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";

import moment from "moment";
import api from "../../../utils/api";
// import StateAuditLogDropdown from "./StateAusss

export default function UserProfileSupportedStatusHistoryDataModal(props) {
  const [
    userProfileSupportedStatusHistory,
    setUserProfileSupportedStatusHistory,
  ] = useState();

  useEffect(() => {
    api
      .getUserProfileSupportedStatusHistory({
        nUserId: props.nUserId,
        sEmailAddress: props.sEmailAddress,
      })
      .then((d) => {
        setUserProfileSupportedStatusHistory(d);
      });
  }, []);

  const renderFields = () => {
    let fields = [];
    if (userProfileSupportedStatusHistory) {
      fields = userProfileSupportedStatusHistory.data.map((e) => {
        return (
          <tr>
            <td>
              {moment(moment.utc(e["dtSupported"]).toDate()).format(
                "MMMM Do YYYY, h:mm:ss a"
              )}
            </td>
            <td>{e["sSupportedStatus"]}</td>
            <td>
              {moment(moment.utc(e["dtModified"]).toDate()).format(
                "MMMM Do YYYY, h:mm:ss a"
              )}
            </td>
          </tr>
        );
      });
    }
    return fields;
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent>
        <div className="p-2 modals-headers-bar">
          <span>Status change history</span>
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={props.toggleModal}
          >
            <X style={{ pointerEvents: "none" }} color="white" />
          </button>
        </div>
        <div
          className="modal-body"
          style={{ overflowY: "scroll", height: "400px" }}
        >
          {renderFields().length !== 0 ? (
            <table>
              <tr>
                <th>Supported Status Changed Date</th>
                <th>Supported Status</th>
                <th>Supported Date</th>
              </tr>
              {renderFields()}
            </table>
          ) : (
            <span>No data to show</span>
          )}
        </div>
      </ModalContent>
    </Modal>
  );
}
